export default "__VITE_ASSET__BPRlKnFO__"